/** Portal Planning page for the logged-in model. */
import { useTranslation } from "react-i18next";
import PortalPageHeader from "../../components/portal/PortalPageHeader";
import PlanningCalendar from "../../components/planning/PlanningCalendar";
import { planningPortalApi } from "../../api/planning";

export default function PortalPlanning() {
  const { t } = useTranslation();
  return (
    <div data-testid="portal-planning-page" className="space-y-8">
      <PortalPageHeader
        kickerKey="portal.placeholder.kicker"
        titleKey="portal.nav.planning"
        subtitleKey="portal.pages.planning_desc"
      />
      <PlanningCalendar
        api={planningPortalApi}
        canEditVisibility={false}
        testId="portal-planning-calendar"
      />
    </div>
  );
}
